import script from "./AddEstimate.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEstimate.vue?vue&type=script&setup=true&lang=js"

import "./AddEstimate.vue?vue&type=style&index=0&id=02b5c526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b5c526"]])

export default __exports__